import { create } from 'zustand';
import { getAllTalents } from '@libs/api/talents';
import { TalentStaffingType } from '@libs/models/talents';
import { FiltersCollection } from '../filters';
import { StaffListItem } from '@libs/models/talents/talent';

type InitialState = {
  loading: boolean;
  initiated: boolean;
  data: StaffListItem[];
  loadData: (search?: string, filters?: FiltersCollection) => void;
};

export const useAssignStore = create<InitialState>()((set) => ({
  loading: false,
  initiated: false,
  data: [],
  loadData: async (search, filters) => {
    set({ loading: true });
    try {
      const talents = await getAllTalents({
        search,
        filters,
      });
      set({
        loading: false,
        data: talents,
      });
    } finally {
      set({ loading: false, initiated: true });
    }
  },
}));
